<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Nova solicitação de notícia</span>
      </h1>
      <div>
        <PrimaryButton class="px-5" @click="submit()" icon="fa-solid fa-paper-plane">
          Solicitar</PrimaryButton>
      </div>
    </div>
  </div>

  <div v-if="!loading" class="align p-4 space_title">
    <div class="row">
      <div class="col-12 col-lg-8 mb-4">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <InputText label="Título sugerido" v-model="articleRequest.title" :error="formErrors.title" />
              </div>

              <div class="col-12 mb-3">
                <InputText label="URL" v-model="articleRequest.url" :error="formErrors.url" />
              </div>

              <div class="col-12 mb-3">
                <TextArea label="Descrição" v-model="articleRequest.content" :error="formErrors.content" style="height: 190px" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="p-4">
            <div class="row">

              <ImageUpload class="mb-3" v-model="articleRequest.cover_image" :preview="articleRequest.cover_image_file_url"
                :error="formErrors.cover_image" />

              <div class="col-12 mb-3">
                <InputText label="Créditos da imagem" v-model="articleRequest.cover_image_credits"
                  :error="formErrors.cover_image_credits"  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import RedirectBack from '@/components/RedirectBack.vue'

import { inject, onBeforeMount, onMounted, ref } from 'vue'
import ImageUpload from '@/components/ImageUpload.vue'
import { useArticleStore } from '@/stores/ArticleStore'

import { storeToRefs } from 'pinia'
import { useToast, TYPE } from "vue-toastification"
import { useRoute, useRouter } from 'vue-router'
import TextArea from '@/components/TextArea.vue'
import {errorFormat} from "@/utils/errorFormat";

const toast = useToast();
const loader = inject('$loader');
const loading = ref(false);
const processing = ref(false);

const router = useRouter();
const route = useRoute();

const articleStore = useArticleStore();
const { articleRequest } = storeToRefs(articleStore);

onBeforeMount(async () => {
  articleRequest.value = {};
  articleRequest.value.references = [null];
});

onMounted(async () => {
  const id = route.params.id;
  if (route.name == 'articleEdit') {
    loader.show();
    loading.value = true;

    await articleStore.getArticle(id);

    loader.hide();
    loading.value = false;
  }
});

const formErrors = ref({});

const submit = async () => {
  if(processing.value == true){
    return;
  }

  let params = {
    title: articleRequest.value.title,
    url: articleRequest.value.url,
    content: articleRequest.value.content,
    image: articleRequest.value.image,
    image_credits: articleRequest.value.image_credits,
  };


  loader.show();
  formErrors.value = {};
  processing.value = true;

  const formResult = await articleStore.createArticleRequest(params);
  if (formResult.success) {
    toast('Solicitação enviada', { type: TYPE.SUCCESS, timeout: 6000 });
    router.push({ name: 'articlesRequests' });
  }
  else {
    formErrors.value = errorFormat(formResult.errors);

    if(formResult.message){
      toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
    }
  }

  processing.value = false;
  loader.hide();
};
</script>